<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Form Change History</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <div *ngIf="auditFormItems.length == 0" class="alert alert-info">
    No Changes
  </div>

  <div *ngIf="auditFormItems.length > 0" class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
    <table mat-table [dataSource]="auditFormItems" class="small">

      <ng-container matColumnDef="fieldName">
        <mat-header-cell *matHeaderCellDef>Field.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.fieldName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="oldValue">
        <mat-header-cell *matHeaderCellDef>Old Value.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.oldValue}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="newValue">
        <mat-header-cell *matHeaderCellDef>New Value.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.newValue}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="byUser">
        <mat-header-cell *matHeaderCellDef>User.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.byUser}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="dateChanged">
        <mat-header-cell *matHeaderCellDef>Date Updated.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.dateChanged}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let item; columns: displayedColumns;"></mat-row>

    </table>
  </div>

</div>